/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "./style.scss";
import PrimaryButton from "../../common/primaryButton/PrimaryButton";
import SecondaryButton from "../../common/secondaryButton/SecondaryButton";
import { NavLink } from "react-router-dom";

import Cookies from "js-cookie";
import { scrollToTop } from "../../common/ScrollToTop";

const CookiesPopup = () => {
  const [visible, setVisible] = useState(false);

  const getAllowedCookie = Cookies.get("wordpress_gdpr_cookies_allowed");
  const getNotAllowedCookie = Cookies.get("wordpress_gdpr_cookies_declined");

  const handleAcceptRejectCookie = (c_val) => {
    let days = 365;
    let expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + days);

    Cookies.set("expiry", expirationDate.toISOString(), { expires: days });
    if (c_val === "allowed") {
      Cookies.set("wordpress_gdpr_cookies_allowed", true, { expires: days });
      Cookies.set("wordpress_gdpr_cookies_declined", false, { expires: days });
    } else {
      Cookies.set("wordpress_gdpr_cookies_allowed", false, { expires: days });
      Cookies.set("wordpress_gdpr_cookies_declined", true, { expires: days });
    }
    setVisible(false);
  };

  const checkAndRemoveExpiredCookies = () => {
    let storedExpirationDate = Cookies.get("expiry");

    if (storedExpirationDate) {
      let expirationDate = new Date(storedExpirationDate);
      if (new Date() > expirationDate) {
        Cookies.remove("wordpress_gdpr_cookies_allowed");
        Cookies.remove("wordpress_gdpr_cookies_declined");
        Cookies.remove("expire");
      }
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (getAllowedCookie === undefined && getNotAllowedCookie === undefined) {
        setVisible(true);
      } else {
        checkAndRemoveExpiredCookies();
      }
    }, 1000);
    return () => clearTimeout(timer); // Cleanup timeout on unmount
  }, [getAllowedCookie, getAllowedCookie]);

  return (
    <section className={`cookies-popup ${!visible ? "hide" : ""}`}>
      <div className="container">
        <p>
          We use cookies to give you the best online experience. By agreeing you
          accept the use of cookies in accordance with our cookie policy.
        </p>
        <div className="cookies-buttons">
          <PrimaryButton
            btnText="I Accept"
            noBtnIcon
            click={() => {
              handleAcceptRejectCookie("allowed");
            }}
          />
          <SecondaryButton
            btnText="I Decline"
            noBtnIcon
            click={() => {
              handleAcceptRejectCookie("not_allowed");
            }}
          />
        </div>
        <div className="links">
          <NavLink to="/cookie-policy" onClick={scrollToTop}>
            {" "}
            Cookie Policy
          </NavLink>
          <NavLink to="/privacy-policy" onClick={scrollToTop}>
            {" "}
            GDPR Policy
          </NavLink>
        </div>
      </div>
    </section>
  );
};

export default CookiesPopup;
